import { EndpointBuilder, TagDescription } from '@reduxjs/toolkit/query';
import { GlobalResponse } from '~/models/Commons ';
import { getHeaders } from './Header';

// Generic helper for delete mutations
const buildDeleteMutation = <TResponse, TId extends string | number>(
  builder: EndpointBuilder<any, any, any>,
  basePath: string,
  invalidatesTags?: readonly TagDescription<string>[]
) =>
  builder.mutation<GlobalResponse<TResponse>, TId>({
    query: (id) => {
      const token = sessionStorage.getItem('access_token');
      if (!token) {
        throw new Error('No access token found');
      }

      return {
        url: `${basePath}/${id}`,
        method: 'DELETE',
        credentials: 'include',
        headers: getHeaders(),
      };
    },
    invalidatesTags,
  });

export default buildDeleteMutation;